module.exports = __webpack_public_path__ + "img/tu04.4ff1159e.png";